import * as React from 'react'

import { EmployeesShowPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import TaskElement from 'modules/tasks/components/TaskElement'
import { TaskIdentifier } from 'modules/tasks/lib/task'

const Component: React.FC = () => {
  const { navigation: navigation } = useNavigation()

  const { id, taskId } = useStrictParams<'id' | 'taskId'>()
  const back = navigation.employees.id.tasks.fullPath({ id })

  const { data, loading } = useQuery(EmployeesShowPageDocument)
  const canEmployeeManageAnyEmployeeFolder =
    data?.documents._policies.employeeManageAnyEmployeeFolder.can ?? false

  // Show single task from employee page
  return (
    <TaskElement
      taskId={Number(taskId)}
      back={back}
      identifier={TaskIdentifier.Single}
      contractVersions={contractVersions}
      canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
      loading={loading}
    />
  )
}

export default Component
